// Типы для управления заказами
import { z } from "zod";
import { zAddressDataSchema } from "../zAddressInfo";
import { zOrderFiltersSchema, zOrderCommonSchema, zPayerTypeSchema, } from "./order.common";
// Поля vehicleInfo из SQL View v_orders_list
export const zOrderVehicleInfoDtoSchema = z.object({
    // Поля для старых представлений (unassigned_orders и др.)
    vehicleModelName: z.string().nullish(),
    vehicleManufacturerName: z.string().nullish(),
    vehicleBatteryCapacity: z.number().nullish(),
    vehicleConnectorType: z.string().nullish(),
    // Поля из v_orders_list
    idVehicle: z.string().nullish(),
    vehicleModel: z.string().nullish(),
    vehicleBrand: z.string().nullish(),
    vehicleStateNumber: z.string().nullish(),
    vehicleDcPort: z.string().nullish(),
});
// Поля клиента из v_orders_list
export const zOrderClientInfoDtoSchema = z.object({
    clientFirstName: z.string().nullish(),
    clientLastName: z.string().nullish(),
    clientPhone: z.string().nullish(),
    clientCompletedOrdersCount: z.number().nullish(),
});
// Поля для времени зарядки из v_orders_list / orders table
export const zOrderChargingStatsDtoSchema = z.object({
    chargingStartAt: z.string().nullish(),
    historicalChargingTimeSeconds: z.number().nullish(),
    // Кол-во завершённых заказов с зарядной сессией для авто (для пояснения «мало данных»)
    completedChargesCount: z.number().nullish(),
    // snake_case — так хранятся в таблице orders (DB naming inconsistency)
    planned_charging_time_seconds: z.number().nullish(),
    estimated_charging_time_seconds: z.number().nullish(),
});
// Поля маршрута из v_orders_list
export const zOrderRouteInfoDtoSchema = z.object({
    routeId: z.string().nullish(),
    routePlannedStartTime: z.string().nullish(),
    routeStatus: z.string().nullish(),
});
// FR-007: поля плательщика из v_orders_list / unassigned_orders (контракт v2.0 §8).
// nullish — колонки добавлены в конец view, у старых строк их может не быть.
// corp_company_id — колонка самой таблицы orders: её читает getOrder (карточка) и пишет прямой INSERT
// (§5.4). У строки таблицы нет payerType — плательщик определяется по ней.
export const zOrderPayerDtoSchema = z.object({
    corpCompanyId: z.string().nullish(),
    corpCompanyName: z.string().nullish(),
    payerType: zPayerTypeSchema.nullish(),
    corp_company_id: z.string().nullish(),
});
export const zOrderSchemaDto = zOrderCommonSchema
    .extend(zAddressDataSchema.shape)
    .extend(zOrderVehicleInfoDtoSchema.shape)
    .extend(zOrderClientInfoDtoSchema.shape)
    .extend(zOrderChargingStatsDtoSchema.shape)
    .extend(zOrderRouteInfoDtoSchema.shape)
    .extend(zOrderPayerDtoSchema.shape);
// Тело прямого INSERT в таблицу orders. corp_company_id — snake_case: это колонка
// таблицы, а не view (контракт v2.0 §5.4). corp_link_id, снимок тарифа и
// payment_card_id проставляет триггер fn_trg_orders_corp_guard — фронт их не шлёт.
export const zCreateOrderSchemaDto = zOrderSchemaDto.omit({ id: true });
// FR-007: тело UPDATE. Поля плательщика и снимка исключены полностью — полный DTO
// с corp_company_id: null у корп-заказа означал бы смену плательщика (CP008),
// хотя пользователь ничего не менял. Триггер сравнивает через IS DISTINCT FROM,
// поэтому достаточно не отправлять ключ вовсе.
export const zUpdateOrderSchemaDto = zCreateOrderSchemaDto.omit({
    corp_company_id: true,
    corpCompanyId: true,
    corpCompanyName: true,
    payerType: true,
});
export const zOrderFiltersSchemaDto = zOrderFiltersSchema;
